module.exports = __webpack_public_path__ + "static/img/s1.7ebee40c.png";